'use client';

import { useEffect, useState } from 'react';

import { useFullscreen } from '~/contexts';
import { Header } from '~/shared/components';
import { DesktopMenu } from '~/shared/components/Nav/components';
import { useResponsive } from '~/shared/hooks';
import { cn } from '~/shared/utils/cn';

type AppTemplateProps = {
  children: React.ReactNode;
};

const isDevelopment = process.env.NODE_ENV === 'development';

export function AppTemplate({ children }: AppTemplateProps) {
  const [isMounted, setIsMounted] = useState(isDevelopment);
  const fullscreen = useFullscreen();
  const { isMobile } = useResponsive({ useOnlyAbiTokens: true });
  const showChrome = fullscreen.deactivated ?? true;
  const isFullscreen = fullscreen.activated ?? false;
  const showAppChrome = isMounted && showChrome;

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      {showAppChrome && <Header />}
      <div className="flex flex-1 min-h-0 bg-[#f5f6f7]">
        {showAppChrome && !isMobile && <DesktopMenu />}
        <main
          className={cn(
            'flex flex-1 flex-col min-h-0 max-w-full overflow-y-auto',
            isFullscreen ? 'p-0' : 'p-page-gutter tabletSm:ml-sidebar-rail'
          )}
        >
          {children}
        </main>
      </div>
    </div>
  );
}
